import React from 'react';
import { Section } from './ui/Section';
export function ContentOverview() {
  const tomos = [{
    title: 'Intervención Inicial',
    desc: 'Encuadre, primera sesión, alianza terapéutica'
  }, {
    title: 'Documentación Clínica',
    desc: 'Historia clínica, registros, consentimientos'
  }, {
    title: 'Captación de Pacientes',
    desc: 'Primeros pacientes, Doctoralia, marketing ético'
  }, {
    title: 'Gestión Administrativa',
    desc: 'Tarifas, cobros, cancelaciones, facturación'
  }, {
    title: 'Continuidad Terapéutica',
    desc: 'Seguimiento, altas, fidelización'
  }, {
    title: 'Ética y Blindaje',
    desc: 'Límites, burnout, autocuidado, prevención'
  }];
  return <Section variant="alt" data-id="element-53">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-3 text-brand-primary" data-id="element-54">
        📚 LOS 6 TOMOS
      </h2>
      <p className="font-body text-center text-brand-textMuted mb-6 text-sm" data-id="element-55">
        Tu consulta completa estructurada
      </p>

      <div className="grid md:grid-cols-2 gap-3 max-w-4xl mx-auto" data-id="element-56">
        {tomos.map((tomo, i) => <div key={i} className="bg-white border-l-4 border-brand-accent p-4 shadow-sm" data-id="element-57">
            <div className="flex items-start gap-3" data-id="element-58">
              <span className="font-heading font-bold text-brand-accent text-lg shrink-0" data-id="element-59">
                {i + 1}
              </span>
              <div data-id="element-60">
                <h3 className="font-heading font-bold text-brand-primary text-sm mb-1" data-id="element-61">
                  {tomo.title}
                </h3>
                <p className="font-body text-brand-textMuted text-xs" data-id="element-62">
                  {tomo.desc}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}